import VuexPersistence from 'vuex-persist'
import { createStore } from 'vuex'
import * as requests from '@/common/requests'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => {
    // never persist transient loading flags, otherwise a reload
    // mid-fetch restores a stuck spinner
    const persisted = { ...state }
    delete persisted.loadingGroups
    delete persisted.navigating
    return persisted
  },
})

export default createStore({
  state: {
    user: {
      username: '',
      email: '',
      wocos: [],
      permissions: {},
    },
    userEmail: null,
    isLoggedIn: false,
    availableGroups: [],
    loadingGroups: false,
    navigating: false,
    selectedGroup: null,
    selectedWoco: null,
    selectedYear: '2021',
    selectedProject: null,
    batchFilter2021: false,
    start: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    resetUser(state) {
      state.user = {
        username: '',
        email: '',
        wocos: [],
        permissions: {},
      }
    },
    setUserEmail(state, userEmail) {
      state.userEmail = userEmail
    },
    setLoggedIn(state, value) {
      state.isLoggedIn = value
    },
    setSelectedWoco(state, value) {
      state.availableGroups = []
      state.selectedGroup = null
      state.selectedWoco = value
    },
    setSelectedYear(state, value) {
      state.availableGroups = []
      state.selectedGroup = null
      state.selectedYear = value
    },
    setSelectedProjectValue(state, value) {
      state.selectedProject = value
    },
    setAvailableGroups(state, groups) {
      state.availableGroups = groups
    },
    setLoadingGroups(state, value) {
      state.loadingGroups = value
    },
    setNavigating(state, value) {
      state.navigating = value
    },
    setBatchFilter2021(state, value) {
      state.batchFilter2021 = value
    },
    setStart(state, time) {
      state.start = time
    },
    setSelectedGroup(state, value) {
      state.selectedGroup = value
    },
  },
  actions: {
    async setSelectedProject({ commit, state }, value) {
      commit('setLoadingGroups', true)
      try {
        const response = await requests.getData(
          `api/group/woco/${state.selectedWoco}/project/${value}/`
        )
        if (!response.data.data) {
          console.error('No data in response from B2B API', response)
          return
        }

        commit('setAvailableGroups', [])
        commit('setSelectedGroup', null)
        if (response.status === 'OK') {
          const groups = response.data.data.groups
            .filter((group) => !group.is_private || group.created_by === state.userEmail)
            .filter((group) => group.apps.some((app) => app.name === 'B2B'))
          commit('setAvailableGroups', groups)
        }
        commit('setSelectedProjectValue', value)
      } finally {
        commit('setLoadingGroups', false)
      }
    },
  },
  modules: {},
  plugins: [vuexLocal.plugin],
})
